/**
 * @file Identity Related mutations.
 */

import gql from 'graphql-tag';

import {
  SelfieStationIdentityDetails,
  SelfieStationRosterIdentityDetails,
} from '../fragments/identity';

export const SelfieStationUpdateSelfie = gql`
  mutation SelfieStationUpdateSelfie($input: UpdateSelfieInput!) {
    updateSelfie(input: $input) {
      identity {
        ...SelfieStationIdentityDetails
      }
    }
  }
  ${SelfieStationIdentityDetails}
`;

export const RosterIdentityCreate = gql`
  mutation RosterIdentityCreate($input: RosterIdentityCreateInput!) {
    rosterIdentityCreate(input: $input) {
      roster_identity {
        id
        ...SelfieStationRosterIdentityDetails
      }
    }
  }
  ${SelfieStationRosterIdentityDetails}
`;

export const RosterIdentityUpdate = gql`
  mutation RosterIdentityUpdate($input: RosterIdentityUpdateInput!) {
    rosterIdentityUpdate(input: $input) {
      roster_identity {
        id
        ...SelfieStationRosterIdentityDetails
      }
    }
  }
  ${SelfieStationRosterIdentityDetails}
`;
